export const FETCH_THEME_S3_REQUEST= 'FETCH_THEME_S3_REQUEST';
export const FETCH_THEME_S3_SUCCESSFUL= 'FETCH_THEME_S3_SUCCESSFUL';
export const FETCH_THEME_S3_FAILURE = 'FETCH_THEME_S3_FAILUIRE';
export const UPDATE_THEME_LOCAL = 'UPDATE_THEME_LOCAL';